import { Injectable } from '@angular/core';
import { ColorIndex, IconType, LayerIndex, ShapeType } from 'src/app/fleet-tracker/model/enum.model';
import { FenceLayerModel, FenceModel, MarkerLayerModel, MarkerModel } from 'src/app/fleet-tracker/model/models';
import { Activation, DeviceGeofenceService } from './device-geofence.service';

// export interface AppData { vehicleName: string; } // boring example of a generic data property for markers

// const historyModeVehicleLimit = 1000;
// const mapMarkerFontSize = '10px';
export const demo = {

    // =========== Live Options ===========

    showLive: false,
    cluster: true,
    refresh: 30000,
    maxLiveVehicles: 10000,

    // =========== Trail Options (must set showLive = false) ===========

    showTrails: true,
    showCrumbs: false,
    showTraces: true,
    showTrips: true,
    showMarkers: true,
    showAddresses: true,
    maxHistoricVehicles: 100, // throws if > historyModeVehicleLimit

    // =========== General Options ===========

    // spatial demo
    searchLat: 33.749,
    searchLng: -40.0000,
    searchRadius: 10,

    // risk demo
    showRisk: false,

    // geofences
    showFences: true,

    // theme demo
    darkness: false,

    // bounds demo
    showBounds: true,

    // padding demo
    addPadding: true,

    // dynamic layer demo
    showDynamicLayer: false
};

@Injectable({
    providedIn: 'root'
})
export class GeofencePrivacyLayerService {
    constructor(private _deviceGeofenceService: DeviceGeofenceService) { }

    async getGeofenceActivations(serialNumber?: string): Promise<MarkerLayerModel<Activation>> {
        var endDate = new Date();
        var startDate = new Date(endDate);
        startDate.setDate(endDate.getDate() - 7);

        var activations = await this._deviceGeofenceService.getActivations(serialNumber, startDate.toISOString(), endDate.toISOString());

        var activationMarkers: MarkerModel<Activation>[] = activations.map(activation => {
            return {
                id: `${activation.serialNumber}-${activation.timestamp}`,
                icon: activation.crossing.crossedInto ? IconType.GeofenceInStart : IconType.GeofenceOutEnd,
                draggable: false,
                color: ColorIndex.C00,
                lat: activation.crossing.segment[0].latitude,
                lng: activation.crossing.segment[0].longitude,
                payload: activation
            }
        });

        return { layer: LayerIndex.Marker, markers: activationMarkers }
    }

    async getGeofence(activation: Activation): Promise<FenceLayerModel<any>> {
        console.log(activation);
        var geofence = await this._deviceGeofenceService.getGeofenceByFenceId(activation.fenceId);

        var offset = activation.offset ? activation.offset : { latitude: 0, longitude: 0 };
        let fenceModel: FenceModel<any> = {
            shape: ShapeType.polygon,
            points: geofence.geometry.coordinates[0].map(point => {
                return { lat: point.latitude + offset.latitude, lng: point.longitude + offset.longitude }
            }),
            payload: geofence,
            markerModel: null
        }

        return { layer: LayerIndex.Fence, fences: [fenceModel], showMarker: false };
    }
}

export class LatLng {
    fenceId: string;
    lat: number;
    lng: number;
}